module.exports = "<section class=\"app-footer\">\n  <div class=\"container-fluid\">\n    <span class=\"float-left\">\n      <span>&nbsp;</span>\n    </span>\n    <span class=\"float-right\">\n      <span>메쉬코리아 고객센터 1800-8255 </span>\n    </span>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/layout/footer/footer.component.html
// module id = ../../../../../src/app/layout/footer/footer.component.html
// module chunks = 3